// this method is in a seperate file so we can spy on it in tests
export const getSnapshotFields = snapshot => {
  const current = snapshot.current;
  return {
    lastMessageId: current.lastMessageId,
    lastMessageOffsetTop: current.lastMessageOffsetTop,
    prevScrollTop: current.prevScrollTop
  };
};